import React, { useState, useEffect } from "react";
import Layout from "./../components/layout/Layout";
import { graphql, navigate } from "gatsby";
import { stringify, parse } from "query-string";
import DynamicComparisonTable from "../components/DynamicComparisonTable";
import { getFrontmatter } from "../utils/functions";
// import ComparisonSearchModal from "../components/ComparisonSearchModal";
import ComparisonSearch from "../components/ComparisonSearch";
import Article from "../components/layout/Article";

const CompareBoards = ({
  data,
  pageContext: { category, title, boardsPath },
  location,
}) => {
  const frontmatter = getFrontmatter(category);
  const allBoardsData = data.allMarkdownRemark.edges.map(({ node }) => ({
    id: node.id,
    slug: node.fields.slug,
    ...node[frontmatter],
  }));

  const [showModal, setShowModal] = useState(false);
  const [addedBoards, setAddedBoards] = useState([]);
  const [availableBoards, setAvailableBoards] = useState(allBoardsData);

  const removeBoard = id => {
    if (isBoardAdded(id)) {
      let { ids: currentIds } = parse(location.search, {
        arrayFormat: "comma",
      });

      let newQuery = {};

      if (currentIds) {
        if (!Array.isArray(currentIds)) currentIds = [currentIds];

        const index = currentIds.findIndex(addedId => addedId === id);
        currentIds.splice(index, 1);

        newQuery = {
          ids: [...currentIds],
        };

        // console.log("new query", newQuery);
        navigate(
          `/compare/${boardsPath}?${stringify(newQuery, {
            arrayFormat: "comma",
          })}`
        );
      }
    }
  };
  const addBoard = (_, { id }) => {
    if (!isBoardAdded(id) && addedBoards.length < 4) {
      const boardToAdd = allBoardsData.find(board => board.id === id);

      if (boardToAdd) {
        let { ids: currentIds } = parse(location.search, {
          arrayFormat: "comma",
        });

        let newQuery = {};

        if (currentIds) {
          if (!Array.isArray(currentIds)) currentIds = [currentIds];

          newQuery = {
            ids: [...currentIds, boardToAdd.id],
          };
        } else {
          newQuery = {
            ids: [boardToAdd.id],
          };
        }
        navigate(
          `/compare/${boardsPath}?${stringify(newQuery, {
            arrayFormat: "comma",
          })}`
        );
        // console.log("new query", newQuery);
      }
    }
  };
  const updateBoards = ids => {
    const temp = allBoardsData;
    const boards = [];

    if (ids && !Array.isArray(ids)) ids = [ids];

    ids.forEach(id => {
      const boardToAdd = allBoardsData.find(board => board.id === id);

      if (boardToAdd) {
        boards.push(boardToAdd);

        const index = temp.findIndex(board => board.id === id);
        temp.splice(index, 1);
      }
    });

    setAddedBoards([...boards]);
    setAvailableBoards([...temp]);
  };
  const isBoardAdded = id => {
    return addedBoards.length > 0 && addedBoards.some(board => board.id === id);
  };

  useEffect(() => {
    const parsed = parse(location.search, { arrayFormat: "comma" });
    // console.log(parsed);
    if (parsed?.ids && parsed?.ids.length > 0) {
      updateBoards(parsed.ids);
    } else {
      updateBoards([]);
    }

    // return () => {
    //   location.state = {};
    //   console.log("State emptied");
    // };
  }, [location]);

  return (
    <Layout>
      <Article title={title}>
        <p className="text-base text-gray-700 mb-4 sm:text-lg">
          Compare specifications of up to four boards. Type a board name in the
          search field of the comparison tool.
          {/* or pick a
          popular device from the ones below. */}
        </p>
        <ComparisonSearch
          category={category}
          onSelectOption={addBoard}
          availableBoards={availableBoards}
        />
        <DynamicComparisonTable
          category={category}
          boardsData={addedBoards}
          onRemoveBoard={removeBoard}
        />
      </Article>
    </Layout>
  );
};

export const compareBoardsPageQuery = graphql`
  query($category: String!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___title], order: ASC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      edges {
        node {
          id
          ...MCUFrontmatter
          ...SBCFrontmatter
          fields {
            slug
          }
        }
      }
    }
  }
`;
export default CompareBoards;
